import React from 'react';

/* Logo MAW Finanças — barras douradas + seta + moeda, texto MAW prata, FINANÇAS dourado */
export function MawLogoFull({ size = 1 }) {
  const w = 180 * size;
  const h = 80 * size;
  return (
    <svg width={w} height={h} viewBox="0 0 180 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="goldBar" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#f0d060"/>
          <stop offset="100%" stopColor="#b8820a"/>
        </linearGradient>
        <linearGradient id="silverArrow" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#d0d8e8"/>
          <stop offset="100%" stopColor="#8898b0"/>
        </linearGradient>
        <linearGradient id="coinGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#f0d060"/>
          <stop offset="100%" stopColor="var(--gold)"/>
        </linearGradient>
      </defs>

      {/* Barras do gráfico */}
      <rect x="14" y="26" width="9" height="16" rx="2" fill="url(#goldBar)"/>
      <rect x="26" y="18" width="9" height="24" rx="2" fill="url(#goldBar)"/>
      <rect x="38" y="10" width="9" height="32" rx="2" fill="url(#goldBar)"/>

      {/* Arco/swoosh prata */}
      <path d="M10 42 Q28 52 46 38" stroke="url(#silverArrow)" strokeWidth="2.5" fill="none" strokeLinecap="round"/>

      {/* Seta diagonal */}
      <line x1="38" y1="20" x2="54" y2="8" stroke="url(#silverArrow)" strokeWidth="2.5" strokeLinecap="round"/>
      <polyline points="48,6 54,8 52,14" stroke="url(#silverArrow)" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>

      {/* Moeda */}
      <circle cx="52" cy="34" r="8" fill="url(#coinGrad)" />
      <circle cx="52" cy="34" r="6" fill="none" stroke="#8B6914" strokeWidth="1"/>
      <text x="52" y="38" textAnchor="middle" fontSize="8" fontWeight="800" fill="#0d1b2a">$</text>

      {/* Texto MAW */}
      <text x="68" y="30" fontFamily="'Inter','Arial Black',sans-serif" fontSize="22" fontWeight="900" letterSpacing="2" fill="#ffffff">MAW</text>

      {/* Texto FINANÇAS */}
      <text x="68" y="46" fontFamily="'Inter','Arial',sans-serif" fontSize="9" fontWeight="700" letterSpacing="3" fill="var(--gold)">FINANÇAS</text>
    </svg>
  );
}

/* Versão compacta: só o ícone (quadrado, para sidebar collapsed) */
export function MawLogoIcon({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="goldBar2" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#f0d060"/>
          <stop offset="100%" stopColor="#b8820a"/>
        </linearGradient>
        <linearGradient id="silverArrow2" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#d0d8e8"/>
          <stop offset="100%" stopColor="#8898b0"/>
        </linearGradient>
        <linearGradient id="coinGrad2" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#f0d060"/>
          <stop offset="100%" stopColor="var(--gold)"/>
        </linearGradient>
      </defs>
      {/* Barras */}
      <rect x="5"  y="18" width="5" height="10" rx="1.5" fill="url(#goldBar2)"/>
      <rect x="12" y="13" width="5" height="15" rx="1.5" fill="url(#goldBar2)"/>
      <rect x="19" y="8"  width="5" height="20" rx="1.5" fill="url(#goldBar2)"/>
      {/* Seta */}
      <line x1="20" y1="13" x2="30" y2="6" stroke="url(#silverArrow2)" strokeWidth="2" strokeLinecap="round"/>
      <polyline points="26,4 30,6 28,10" stroke="url(#silverArrow2)" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
      {/* Swoosh */}
      <path d="M4 27 Q14 33 26 24" stroke="url(#silverArrow2)" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
      {/* Moeda */}
      <circle cx="29" cy="22" r="6" fill="url(#coinGrad2)"/>
      <text x="29" y="26" textAnchor="middle" fontSize="7" fontWeight="900" fill="#0d1b2a">$</text>
    </svg>
  );
}

/* Logo para tela de login (maior, sobre fundo escuro) */
export function MawLogoLogin() {
  return (
    <svg width="220" height="100" viewBox="0 0 220 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="goldBarL" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#f5dc70"/>
          <stop offset="100%" stopColor="var(--gold)"/>
        </linearGradient>
        <linearGradient id="silverArrowL" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#e8eef8"/>
          <stop offset="100%" stopColor="#9aaac0"/>
        </linearGradient>
        <linearGradient id="coinGradL" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#f5dc70"/>
          <stop offset="100%" stopColor="var(--gold)"/>
        </linearGradient>
        <filter id="glow">
          <feGaussianBlur stdDeviation="1.5" result="blur"/>
          <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
      </defs>

      {/* Barras */}
      <rect x="14" y="30" width="12" height="20" rx="3" fill="url(#goldBarL)" filter="url(#glow)"/>
      <rect x="30" y="20" width="12" height="30" rx="3" fill="url(#goldBarL)" filter="url(#glow)"/>
      <rect x="46" y="10" width="12" height="40" rx="3" fill="url(#goldBarL)" filter="url(#glow)"/>

      {/* Swoosh */}
      <path d="M10 52 Q32 64 56 48" stroke="url(#silverArrowL)" strokeWidth="3" fill="none" strokeLinecap="round"/>

      {/* Seta */}
      <line x1="48" y1="24" x2="66" y2="10" stroke="url(#silverArrowL)" strokeWidth="3" strokeLinecap="round"/>
      <polyline points="58,7 66,10 63,18" stroke="url(#silverArrowL)" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>

      {/* Moeda */}
      <circle cx="64" cy="40" r="11" fill="url(#coinGradL)" filter="url(#glow)"/>
      <circle cx="64" cy="40" r="8.5" fill="none" stroke="#8B6914" strokeWidth="1.2"/>
      <text x="64" y="45" textAnchor="middle" fontSize="11" fontWeight="900" fill="#0d1b2a">$</text>

      {/* MAW */}
      <text x="84" y="38" fontFamily="'Inter','Arial Black',sans-serif" fontSize="32" fontWeight="900" letterSpacing="3" fill="#ffffff">MAW</text>

      {/* FINANÇAS */}
      <text x="84" y="56" fontFamily="'Inter','Arial',sans-serif" fontSize="12" fontWeight="700" letterSpacing="4" fill="var(--gold)">FINANÇAS</text>
    </svg>
  );
}
